import type { V2File } from 'clients/api/fileUploads';
import { getGlyphName } from 'lib/FileTypes';
import Glyph from 'components/Glyph';
import Link from 'components/Link';
import * as React from 'react';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'file... Remove this comment to see the full error message
import filesize from 'filesize';
import './styles/FilePreview.scss';

export type FilePreviewerProps = {
  file: V2File;
};

// TODO rename to FileGenericPreview now that we have lots of File previewing components
// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '$FlowFixMeState'.
class FilePreview extends React.Component<FilePreviewerProps, $FlowFixMeState> {
  state = {
    isHovering: false,
  };

  endHover = () => {
    this.setState({ isHovering: false });
  };

  startHover = () => {
    this.setState({ isHovering: true });
  };

  render() {
    const { file } = this.props;

    const size = file.size;
    let displayedSize = '';
    if (size) {
      displayedSize = filesize(size, { round: 1, spacer: '' }).toUpperCase();
    }

    const contentType = file.content_type;
    const preview = (
      <Link
        className="FilePreview"
        href={file.urls.cdn}
        target="_blank"
        eventElementName="FilePreview"
      >
        <div
          className="FilePreview-preview"
          onMouseEnter={this.startHover}
          onMouseLeave={this.endHover}
        >
          <Glyph
            className="FilePreview-icon"
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            name={this.state.isHovering ? 'download' : getGlyphName(contentType)}
            size="xxxlarge"
          />
          <div className="FilePreview-name">{file.name}</div>
          <div className="FilePreview-size">
            <em>{displayedSize}</em>
          </div>
        </div>
      </Link>
    );

    return preview;
  }
}

export default FilePreview;
